import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ErrorsLogRoutingModule } from './errors-log-routing.module';
import { ErrorsLogComponent } from './errors-log.component';
import { DxDataGridModule, DxSelectBoxModule, DxTextBoxModule, DxCheckBoxModule, DxTagBoxModule, DxAutocompleteModule } from 'devextreme-angular';
import { I18nModule } from 'app/shared/i18n/i18n.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MaterialModule } from 'app/material.module';

@NgModule({
  declarations: [ErrorsLogComponent],
  imports: [
    CommonModule,
    ErrorsLogRoutingModule,
    DxDataGridModule,
    I18nModule,
    ReactiveFormsModule,
    FormsModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxCheckBoxModule,
    DxTagBoxModule,
    DxAutocompleteModule,
    MaterialModule
  ]
})
export class ErrorsLogModule { }
